import 'date-fns';
import React, { useState, useEffect } from 'react';
import { Button } from '@material-ui/core';
import {Time} from './Time'

export const AvailableSlots = ({ onChange, name, label, defaultValue, ...restProps }) => {
  // The first commit of Material-UI

  const [slot, setSlot] = useState([])
  const [count, setCount] = useState(0)

  useEffect(() => {
    onChange({ target: { name: name, value: slot } })
  }, [slot])
  
  useEffect(()=> {
    if (defaultValue) {
      setSlot(defaultValue)
      setCount(defaultValue.length)
    }
  }, [])


  const handleSlots = (e, index) => {
    const dupSlot = slot
    dupSlot[index] = e
    setSlot([...dupSlot])
  }

  const removeFinalSlot = (event) => {
    event.preventDefault()
    if (event) {
      if (slot.length > 0) {
        const newArray = slot.slice(0, slot.length - 1)
        setSlot(newArray)
      }
    }

  }

  return (
    <>
      <p>Consultation Availability *</p>
      <Button color="primary" type="button" onClick={() => setCount(count + 1)}>Add Slot</Button>
      <Button disabled={!count} color="secondary" type="button" onClick={(e) => {
        setCount(count - 1)
        removeFinalSlot(e)
      }}>Remove Slot</Button>
      {Array(count).fill(0).map((e,i)=> {
        return <Time  onChange={handleSlots} defaultValue={slot && slot[i]} index={i}/>
      })}
    </>)

}
